import { Edit } from "@/components/admin/edit";
import { NumberInput } from "@/components/admin/number-input";
import { SimpleForm } from "@/components/admin/simple-form";
import { TextInput } from "@/components/admin/text-input";

export const ProductEdit = () => (
  <Edit title="Editar producto">
    <SimpleForm>
      <TextInput source="clase" label="Clase" />
      <TextInput source="codigo" label="Código" />
      <TextInput source="marca" label="Marca" />
      <TextInput source="origen" label="Origen" helperText="Texto libre — se va confirmando caso por caso" />
      <TextInput source="producto" label="Producto" />
      <TextInput source="medida" label="Medida" />
      <TextInput source="color" label="Color" />
      <TextInput source="textura" label="Textura" />
      <TextInput source="tendencia" label="Tendencia" />
      <TextInput source="formato" label="Formato" />
      <NumberInput source="precio" label="Precio" />
      <NumberInput source="precio_iva" label="Precio + IVA" />
    </SimpleForm>
  </Edit>
);
